<template>
  <main-container title="モデル一覧" class="model-list-container" :showHeader="true" :showFooter="false">
    <template slot="main-header">
      <h1 class="title">モデル一覧</h1>
      <el-switch class="model-list-switch" v-model="showSXModel" active-color="#6ba7ef" inactive-color="#2456d4"
                 active-text="SkyFox標準" inactive-text="ユーザー作成" @change="onChangeShowUserModel"></el-switch>
      <div class="informations-container" style="flex-grow: 1;">
        <div class="information-container" v-if="information">
          <span class="information-label">お知らせ</span>
          <span class="link information-text" @click="onClickInformation('information', 'information-' + information.informationId)">
            {{ information.title }}({{ information.releaseAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DD') }})
          </span>
        </div>
        <div class="information-container information-alert" v-if="overUse > 0">
          <span class="information-label">重要</span>
          <span class="link information-text" v-if="overUse > 1"
                @click="onClickInformation('account', 'billing_this_month')"><strong>今月の利用料が基本料金の利用範囲を超過しています</strong></span>
          <span class="link information-text" v-else @click="onClickInformation('account', 'billing_this_month')">今月の利用料が基本料金の利用範囲を超過しそうです</span>
        </div>
      </div>
      <div style="margin-left: auto; margin-right: 24px;">
        <el-input
          placeholder="モデル名で検索"
          suffix-icon="el-icon-search"
          v-model="searchModelName"
          :clearable="true"
          style="width: 15rem;">
        </el-input>
        <el-button plain v-show="removeModels.length > 0" type="info" :disabled="removeModels.length <= 0" @click="onBulkDeselect">選択を全て解除</el-button>
        <el-button type="danger" :disabled="removeModels.length <= 0" @click="onBulkRemove">一括削除</el-button>
      </div>
    </template>
    <div slot="main-content">
      <div class="model-card-area">
        <div v-if="!showSXModel" class="model-add mode-list-item" @click="onClickAddModel">
          <div class="plus-icon">+</div>
          <div>モデルを追加</div>
        </div>
        <model-list-item v-for="model in displayModels" :key="model.modelId" :item="model" :on-select-mode="removeModels.length > 0"
                         @detail="onDetailModel" @predict="onPredictModel" @delete="onDeleteModel"
                         @confirmed-error="onConfirmedError" @selected="onSelectedModel" @reload="loadModels"
                         @deselected="onDeselectedModel" @putModelName="changeModelNameRequest">
        </model-list-item>
      </div>

      <el-dialog v-if="visibleInformation && popupInformation" custom-class="dialog-size-middle information-dialog"
                 :title="informationDialogTitle" :append-to-body="true" :visible="visibleInformation"
                 @close="visibleInformation=false" top="0" :modal="false">
        <p class="information-dialog-description" v-html="informationDialogDescription"></p>
      </el-dialog>
    </div>
  </main-container>
</template>

<script lang="js">
import BaseView from '../base'
import ModelListItemCmp from '../../components/model/list/item.vue'
import { OverUseType } from '../../defines/enum'
import WebApiClient from '../../api/web'
import CommonUtil from '../../utils/common'
import StorageUtil from '../../utils/storage'
import MessageBox from '../../utils/message-box'
import { Code } from '../../api/base'
import * as Cookies from 'es-cookie'
import FormatUtil from '../../utils/format'
import DateUtil from '../../utils/date'
import { InformationImportance } from '../../defines/const'

export default {
  name: 'ModelListView',
  mixins: [BaseView],
  components: {
    'model-list-item': ModelListItemCmp
  },
  computed: {
    displayModels () {
      if (this.showSXModel === false) {
        return this.modelsGrep.filter(model => model.type !== 'sx')
      } else {
        return this.modelsGrep.filter(model => model.type === 'sx')
      }
    },
    informationDialogTitle () {
      const title = FormatUtil.escapeHtml(this.popupInformation.title)
      const releaseAt = DateUtil.changeFormat(this.popupInformation.releaseAt, 'YYYYMMDDHHmmss', 'YYYY/MM/DD')

      return `${title}(${releaseAt})`
    },
    informationDialogDescription () {
      return FormatUtil.escapeHtml(this.popupInformation.description, {
        nl2br: true,
        enableLink: true
      })
    }
  },
  watch: {
    searchModelName (word) {
      if (word) {
        this.modelsGrep = this.models.filter(
          model => model.modelName.includes(word)
        )
      } else {
        this.modelsGrep = this.models
      }
    }
  },
  data () {
    return {
      models: [],
      modelsGrep: [],
      information: null,
      overUse: OverUseType.Nothing,
      popupInformation: null,
      visibleInformation: false,
      showSXModel: false,
      removeModels: [],
      searchModelName: ''
    }
  },
  beforeMount () {
    this.loadModels()
  },
  methods: {
    loadModels () {
      return WebApiClient.getModels(this).then(response => {
        const result = response.data.result
        this.models = result.models
        this.modelsGrep = result.models
        this.searchModelName = ''
        this.$forceUpdate()
      })
    },
    onRefreshNotification (notifications, onlyIsNewInfo) {
      if (!onlyIsNewInfo) {
        if (CommonUtil.isNotEmpty(notifications.informations)) {
          if (notifications.informations[0].importance === InformationImportance.HIGH) {
            this.information = notifications.informations[0]
          }

          const popupInformation = notifications.informations.slice(-1)[0]
          const alreadyReadInformationId = Cookies.get('INFO_READ')
          if (CommonUtil.isEmpty(alreadyReadInformationId) ||
              popupInformation.informationId !== Number(alreadyReadInformationId)) {
            this.popupInformation = popupInformation
            this.visibleInformation = true
            Cookies.set('INFO_READ', popupInformation.informationId, {
              expires: 1209600
            })
            this.$forceUpdate()
          }
        }
        this.overUse = notifications.overUse
      }
    },
    onSelectedModel (model) {
      if (this.removeModels.indexOf(model) < 0) {
        this.removeModels.push(model)
      }
    },
    onBulkDeselect () {
      for (let model of this.removeModels) {
        model.selected = false
      }
      this.removeModels = []
    },
    onDeselectedModel (model) {
      if (this.removeModels.indexOf(model) >= 0) {
        this.removeModels.splice(this.removeModels.indexOf(model), 1)
      }
    },
    onBulkRemove () {
      const key = '一括削除'
      const message = `選択したモデルを全て削除します<br>(モデルを削除すると適用結果も削除されます)<br><br>削除の確認のため、以下の文言を入力：<br><b>${key}</b>`
      const errorMessage = 'パスワードが違います'

      MessageBox.deleteModelConfirm(this, message, key, errorMessage).then(() => {
        WebApiClient.deleteModel(this, this.removeModels.map(value => value.item.modelId).join(',')).then(async (response) => {
          if (response.data.code === Code.SUCCESS) {
            await this.loadModels()
            this.removeModels.splice(0, this.removeModels.length)
            this.$message({
              message: 'モデルを削除しました',
              type: 'success',
              duration: 2000,
              showClose: true
            })
          } else {
            this.reload()
          }
        })
      }).catch(() => {})
    },
    onClickAddModel () {
      StorageUtil.removeModelInfo(this)
      this.changeLocation('model-train-input')
    },
    onDetailModel (modelListItem) {
      this.changeLocation('model-detail', {
        modelId: modelListItem.modelId,
        modelName: modelListItem.modelName
      })
    },
    onPredictModel (modelListItem) {
      this.changeLocation('model-predict', {
        modelId: modelListItem.modelId
      })
    },
    onDeleteModel (modelListItem) {
      WebApiClient.deleteModel(this, modelListItem.modelId).then(() => {
        this.models.splice(this.models.indexOf(modelListItem), 1)
        this.searchModelName = ''
        this.$forceUpdate()
        this.$message({
          message: 'モデルを削除しました',
          type: 'success',
          duration: 2000,
          showClose: true
        })
      })
    },
    changeModelNameRequest (modelListItem, newName) {
      WebApiClient.putModelName(this, modelListItem.modelId, newName).then(async () => {
        await this.loadModels()
        this.$message({
          message: 'モデル名を変更しました',
          type: 'success',
          duration: 2000,
          showClose: true
        })
      })
    },
    onConfirmedError (modelListItem) {
      WebApiClient.deleteModelError(this, {
        modelId: modelListItem.modelId,
        taskId: modelListItem.taskId
      }).then(() => {
        this.reload()
      })
    },
    onClickInformation (name, hash) {
      this.$router.push({
        name: name,
        hash: `#${hash}`
      })
    },
    onChangeShowUserModel () {
      this.$forceUpdate()
    },
    getDisplayModels () {

    }
  }
}
</script>

<style scoped>
  .model-list-container >>> .main-content {
    padding: 24px;
  }

  h1 {
    display: inline;
  }

  .model-list-switch {
    width: 230px;
    margin: 6px 20px 0;
  }

  .model-list-switch >>> .el-switch__label {
    font-weight: 500;
    color: #999;
  }

  .model-list-switch >>> .el-switch__label.is-active {
    font-weight: 700;
    color: #2456d4;
  }

  .model-card-area {
    display: flex;
    flex-wrap: wrap;
  }

  .model-card-area a {
    text-decoration: none;
  }

  .model-card-area .model-add {
    width: 252px;
    height: 152px;
    border: 1px solid #c0d5ef;
    border-radius: 2px;
    color: #2456d4;
    padding: 16px;
    margin-right: 24px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1.5;
    cursor: pointer;
  }

  .model-card-area .model-add:hover {
    background-color: #f1f9ff;
  }

  .model-card-area .model-add > div {
    display: flex;
    justify-content: center;
  }

  .model-card-area .model-add .plus-icon {
    font-size: 96px;
    align-items: center;
    height: 100px;
  }

  .information-container {
    margin-left: 10px;
  }

  .information-container > .information-label {
    display: inline-block;
    color: #fff;
    font-size: 0.88rem;
    padding: 5px 6px;
    line-height: 1;
    border-radius: 4px;
    margin: 0 10px 0 0;
    text-align: center;
    width: 72px;
    min-width: 72px;
    background-color: #394445;
  }

  .information-container > .information-text {
    color: #2456d4;
    font-size: 1rem;
    line-height: 1;
    text-decoration: none;
  }

  .information-container > .information-text:hover {
    text-decoration: underline;
  }

  .information-container.information-alert > .information-label {
    background-color: #d8243e;
  }

  .information-container.information-alert > .information-text {
    color: #d8243e;
  }

  .el-dialog__wrapper >>> .information-dialog {
    height: auto;
  }

  .el-dialog__wrapper >>> .information-dialog .el-dialog__header {
    padding: 28px 26px;
  }

  .el-dialog__wrapper >>> .information-dialog .el-dialog__body {
    background: #f1f5f8;
    padding: 28px;
    max-height: 530px;
    overflow-y: auto;
  }

  .el-dialog__wrapper >>> .information-dialog .el-dialog__body > .information-dialog-description {
    font-size: 0.95rem;
    line-height: 1.4;
  }

</style>



// WEBPACK FOOTER //
// src/views/model/list.vue